<script setup lang="ts">
import LanCard from "@/components/LanCard.vue";
import { formatEventDate } from "@/lib/dateUtils";
import { useBreakpoints, breakpointsTailwind } from "@vueuse/core";

const emit = defineEmits(["cancelBooking"]);

const props = defineProps({
  events: {
    type: Array,
    required: true,
  },
  uid: {
    type: String,
    required: true,
  },
  findSeat: {
    type: Function,
  },
});

const breakpoints = useBreakpoints(breakpointsTailwind);
const isMobile = breakpoints.smaller("lg"); // true if screen width is less than 'lg' breakpoint

function findSeatName(event) {
  const seat_location = props.findSeat(event, props.uid);
  if (seat_location) {
    const adjustment = seat_location[1] > 2 ? -1 : 0; // Adjust for missing column
    const colLetter = String.fromCharCode(65 + seat_location[1] + adjustment);
    const rowNumber = seat_location[0];
    return colLetter + rowNumber;
  } else {
    return "No seat booked";
  }
}

function cancelBooking(event) {
  emit("cancelBooking", event.id, props.findSeat(event, props.uid));
}
</script>

<template>
  <div>
    <div
      v-if="isMobile"
      class="mb-4 text-2xl font-semibold w-full h-full items-center"
    >
      <div>Your Bookings</div>
    </div>
  </div>
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-3 pb-30">
    <LanCard
      v-for="event in props.events"
      :eventName="event.name"
      :eventId="event.id"
      :date="formatEventDate(event)"
      :seat="findSeatName(event)"
      :imageUrl="event.imageUrl"
      @cancelBooking="cancelBooking(event)"
    ></LanCard>
  </div>
</template>
